import { TransactionsMyWalletCard } from "@/modules/finances/components/transactionsMyWalletCard"
import { PayoutTotalTransferCard } from "@/modules/finances/financesPayout/components/payoutTotalTransferCard"
import { cn } from "@/modules/lib/utils"
import { StripeAccountStatus } from "@/modules/payment/stripeTypes"
import { useUser } from "@/modules/users/hooks/useUser"
import { useCurrentBox } from "@modules/box/hooks/useBox"
import { PayoutTable } from "@modules/finances/financesPayout/components/payoutTable"
import { PayoutEnumApi } from "@modules/finances/financesPayout/gateway/payoutApi"
import { useFinanceStats } from "@modules/finances/hooks/useFinance"
import { monthYearDateFormat } from "@modules/utils/dateUtils"
import dayjs from "dayjs"

export type PayoutLayoutProps = {
  className?: string
} & React.ComponentProps<"div">

export function PayoutLayout({ className, ...props }: PayoutLayoutProps) {
  const { result: box } = useCurrentBox()
  const user = useUser()
  const payoutEnumApi = box ? PayoutEnumApi.OWNER : PayoutEnumApi.ATHLETE
  const isStripeAccountComplete = box
    ? box.stripeAccountStatus === StripeAccountStatus.OK
    : user.stripeAccountStatus === StripeAccountStatus.OK

  const { data: stats } = useFinanceStats(isStripeAccountComplete, dayjs().format(monthYearDateFormat))

  return (
    <div className={cn("flex w-full grow flex-col gap-4", className)} {...props}>
      {/* HEADER */}
      <div className="flex w-full flex-col gap-4 md:flex-row">
        <TransactionsMyWalletCard hideViewPayoutsButton />
        <PayoutTotalTransferCard stats={stats} />
      </div>

      {/* TABLE */}
      <PayoutTable payoutEnumApi={payoutEnumApi} />
    </div>
  )
}
